/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimedSavedStateUpdate } from "./TimedSavedStateUpdate";
import {
  TimedSavedStateUpdateFromJSON,
  TimedSavedStateUpdateFromJSONTyped,
  TimedSavedStateUpdateToJSON,
  TimedSavedStateUpdateToJSONTyped,
} from "./TimedSavedStateUpdate";

/**
 *
 * @export
 * @interface PaginatedTimedSavedStateUpdateList
 */
export interface PaginatedTimedSavedStateUpdateList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TimedSavedStateUpdate>;
}

/**
 * Check if a given object implements the PaginatedTimedSavedStateUpdateList interface.
 */
export function instanceOfPaginatedTimedSavedStateUpdateList(
  value: object
): value is PaginatedTimedSavedStateUpdateList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTimedSavedStateUpdateListFromJSON(
  json: any
): PaginatedTimedSavedStateUpdateList {
  return PaginatedTimedSavedStateUpdateListFromJSONTyped(json, false);
}

export function PaginatedTimedSavedStateUpdateListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTimedSavedStateUpdateList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TimedSavedStateUpdateFromJSON),
  };
}

export function PaginatedTimedSavedStateUpdateListToJSON(
  json: any
): PaginatedTimedSavedStateUpdateList {
  return PaginatedTimedSavedStateUpdateListToJSONTyped(json, false);
}

export function PaginatedTimedSavedStateUpdateListToJSONTyped(
  value?: PaginatedTimedSavedStateUpdateList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TimedSavedStateUpdateToJSON),
  };
}
